import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required } from "../../common/Validations";
import { 
  Container, 
  Box, 
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  InputLabel,
  Fab,
  Grid,
  Paper,
  Typography, 
  Tooltip,
  Input,
  Icon,
  Toolbar,
  MenuItem,  
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import { actionUpdateUser } from '../../actions/UserActions'
import moment from 'moment'
let _handleSubmitFail;
class EditUser extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={imgEdit:null, imgNameEdit:null}
    this.onClean=this.onClean.bind(this)
    this.onSave=this.onSave.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    } 
    let user=this.props.history.location.state//this.props.user
    if(user){  
        this.props.initialize(user)
    }else{
        this.props.history.replace(LOGIN_ROUTE);
    }
  
  }
  
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

    onClean(){
        let user=this.props.history.location.state
        this.props.initialize(user)
  }

  onSave(formValues){
    this.props.actionUpdateUser(formValues
      , ()=>{Util.showNoty(SUCCESS, "El perfil se guardó correctamente."); this.props.history.goBack()}
      , (e)=>{
        console.log("ERROR ON SAVE USER", e)
        if(!(e&&e.status&&e.status==401)){
          const msg = e&&e.body&&e.body.isBussinessError?e.body.msg:"No se pudo guardar el perfil."
          Util.showNoty(ERROR, msg)
        }
      }
    )
  }

  render(){
    const { theme, handleSubmit } = this.props
    const title ="Editar Perfil"
    const user=this.props.history.location.state

    /*
    1- Nombre y Apellido
2- Fecha de cumpleaños.
3- Género
4- Usuario de Instagram
Se podrá modificar el DNI sólo para aquellos usuario que no tengan el DNI en su registro, al momento de ingresar el dni se debe validar que previamente ese dni no se encuentre registrado. Sí el usuario ya tienen cargado el dni previamente NO se podrá modificar éste campo.
    */
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Editar Usuario</Typography>
            <Typography variant="subtitle1">Editar Perfil</Typography>
          </Box>
        </Box>
        <Container>        
          <Paper >
            <Typography style={theme.paper.title} variant="h2">{title}</Typography>
            <form style={theme.paper.form}>
                <Grid container xs={12} spacing={3} direction="row">
                  <Grid item xs={4}>
                    <Field
                        component={TextField}
                        name="proName"
                        label="Nombre"
                        fullWidth
                        validate={[required]}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Field
                        component={TextField}
                        name="proLastName"
                        label="Apellido"
                        fullWidth
                        validate={[required]}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Field
                        component={TextField}
                        name="proDNI"
                        label="DNI"
                        fullWidth
                        disabled={user&&user.proDNI}
                        // validate={[required]}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <Field
                      component={TextField}
                      name="proBirthDate"
                      label="Fecha de nacimiento"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      // validate={[required]}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <InputLabel shrink>Género</InputLabel>
                    <Field
                      component={Select}
                      select
                      name="proGender"
                      fullWidth
                      // validate={[required]}
                    >
                      <MenuItem value="male">Másculino</MenuItem>
                      <MenuItem value="female">Femenino</MenuItem>
                    </Field>  
                  </Grid>
                  <Grid item xs={7}>
                    <Field
                    component={TextField}
                    name="proInstagram"
                    label="Instagram"
                    fullWidth
                    // validate={[required]}
                    />
                  </Grid>
                </Grid>
            </form>
          </Paper>
          <Toolbar style={theme.footer.toolbar}>
            <Tooltip title="Limpiar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.onClean}>Limpiar</Button>
            </Tooltip>
            <Tooltip title="Cancelar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.props.history.goBack}>Cancelar</Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button variant="contained" color="primary" style={theme.footer.button} onClick={handleSubmit(this.onSave)}>Guardar</Button>
            </Tooltip>
          </Toolbar>
        </Container>
      </Box>
    )
  }
}
function mapStateToProps(store) {
  // console.log("STORE EVENT", store)
  return {
    login: store.auth.login,
    user: store.usr.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionUpdateUser,
    },
    dispatch
  );
}

export default  reduxForm({
  form: "editUser",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(EditUser)
    )
  )
)


// WEBPACK FOOTER //
// ./src/screens/users/EditUser.js